<template>
    <el-row :gutter="10">
        <el-col :span="6">
            <el-input
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
            </el-input>
            <el-tree
                    class="filter-tree"
                    :data="data"
                    :props="defaultProps"
                    default-expand-all
                    :filter-node-method="filterNode"
                    @node-click="handleNodeClick"
                    ref="tree">
            </el-tree>

        </el-col>
        <el-col :span="18">
            <el-card class="box-card">
                <div slot="header" class="clearfix">

                    <span v-if="checkDisabled">分配材料-{{nowTown.label}}</span>
                    <span v-if="!checkDisabled" style="color:red;">请点击左侧街镇进行分配</span>
                    <el-button style="float: right; padding: 3px 0" type="text" @click="create('form')"  :disabled="!checkDisabled">保存配置</el-button>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            prop="materialId"
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            label="材料名称"
                            width="380">
                    </el-table-column>
                    <el-table-column
                            prop="explainText"
                            label="描述信息"
                            width="380">
                    </el-table-column>
                    <el-table-column
                            label="上报类型"
                             >
                        <template slot-scope="scope">{{ materialType(scope.row.materialType) }}</template>
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="formType"-->
                            <!--label="表单类型"-->
                            <!--show-overflow-tooltip>-->
                    <!--</el-table-column>-->
                </el-table>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
    import {
        page,
        getAll,
        saveAuthObj,
    } from '@/api/admin/sysBaseMaterialAuth/index';
    import {
        findMaterialList
    } from '@/api/admin/sysBaseMaterial/index';
    import {
        findUserAll
    } from '@/api/admin/user/index';
    import {
        fetchTree
    } from '@/api/admin/group/index';
    import {
        getTree
    } from '@/api/admin/sysBaseTown/index';
    export default {
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val);
            },
            activeName(n,o){
                this.flush(n);
            }
        },
        computed:{
        },
        mounted(){
            this.flush(this.activeName);
            this.loadMaterial();
        },
        methods: {
            flush(n){
                console.log("加载:"+n)
                if(n==0){
                    this.loadTownTree();
                }else if(n==1){
                    this.loadDepartmentTree();
                }else if(n==2){
                    this.findRoleTree();
                }
            },
            materialType(materialType){
                if(materialType==0){return "附件"}
                else if(materialType==1){return "录入"}
                else{return "附件或录入"}
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            handleSelectionChange(val) {
                this.form.materialIds = val.map(x=>x.materialId);
            },
            handleNodeClick(data){
                if(this.activeName!=0 ||  data.type=='street'){
                    this.checkDisabled=true;
                    this.form.authId=data.id;
                    this.nowTown = data;
                    this.$refs.multipleTable.clearSelection();
                    getAll({authType: parseInt(this.activeName), authId: data.id}).then(response => {
                       if(response){
                           response.forEach(x=>{
                               for(let i=0;i<this.tableData.length;i++){
                                   if(this.tableData[i].materialId==x.materialId){
                                       this.$refs.multipleTable.toggleRowSelection(this.tableData[i]);
                                       break;
                                   }
                               }

                           })
                       }

                    });
                }else{
                    this.checkDisabled=false;
                    this.form.authId=0;
                }
            },create(formName) {
                let data = {authType: parseInt(this.activeName), ...this.form}
                saveAuthObj(data).then(() => {
                    this.$notify({
                        title: '成功',
                        message: '分配成功',
                        type: 'success',
                        duration: 2000
                    });
                })
            },
            loadMaterial:function(){
                findMaterialList({}).then(response=>{
                    this.tableData= response;
                });
            },
            findRoleTree:function(){
                // findUserAll({}).then(response=>{
                //     this.data= response.map(x=>{
                //         return {"id": x.userId, "label": x.name};
                //     });
                // });
              fetchTree({groupType:1}).then(data => {
                this.data = data
              })
            },
            loadDepartmentTree:function(){
                fetchTree({groupType:2}).then(data => {
                    this.data = data
                })
            },
            loadTownTree:function(){
                getTree({}).then(data => {
                    this.data = data
                })
            }
        },
        props:["activeName"],
        data() {
            return {
                form:{
                    materialIds: [],
                    authId: 0
                },
                nowTown:{label:""},
                checkDisabled: false,
                filterText: '',
                data: [
//                    {
//                        id: 1,
//                        label: '上海市',
//                        children: []
//                    }
                ],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                tableData: [
//                    {
//                        materialId:1,
//                        materialName:"企业年上报税收表",
//                        explainText:"描述信息",
//                        materialType:1,
//                        formType:"sys_form1",
//                    }
                ]
            };
        }
    };
</script>
